import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { shortId } from 'utils';

import { Icon, DropDown } from 'components/ui';

import { data } from './Sidebar.mocks';

import { logout } from 'store/actions/auth.action';
import { authSelector } from 'store/reducers/auth.reducer';

import styles from './Sidebar.module.scss';
import ReactGA from 'hooks/useGA';
import { Footer } from '../Footer/Footer';

const ProfileDropDown: React.FC<any> = ({ setSidebarOpen }) => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <ul onClick={() => setSidebarOpen(false)}>
      <li>
        <Link to="/profile">Profile</Link>
      </li>
      <li>
        <Link to="/subscription">Subscription</Link>
      </li>
      <li onClick={handleLogout}>Logout</li>
    </ul>
  );
};

export const Sidebar: React.FC<any> = ({ sidebarOpen, setSidebarOpen }) => {
  const { profile } = useSelector(authSelector);

  const handleLinkClick = (label: string) => {
    ReactGA.event({
      category: 'Left Sidebar',
      action: 'Link Click',
      label
    })
  }

  const MobileSidebar = () => (<aside id='sidebar-mobile' className={`sidebar-component d-flex flex-column d-lg-none sidebar-mobile ${sidebarOpen ? 'active' : ''}`}>
    <div className='py-3 mb-5 pl-4 border-bottom'>
      <DropDown placement="bottomRight" content={<ProfileDropDown setSidebarOpen={setSidebarOpen} />}>
        {profile && (
          <div className='profile' onClick={e => { e.stopPropagation() }}>
            {profile.avatarUrl && <img className='avatar' src={profile.avatarUrl} alt="avatar" />}
            <div className={'name'}>{profile.name}</div>
            <Icon name="arrow-down" className={'icon'} />
          </div>
        )}
      </DropDown>
    </div>

    <nav className='pl-4' onClick={() => setSidebarOpen(false)}>
      <ul>
        {data.map(i => (
          <li key={shortId()}>
            <NavLink activeClassName={'is-active'} to={i.url} onClick={() => handleLinkClick(i.title)}>
              <Icon className={styles.icon} name={i.iconName} />
              {i.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
    <Footer className='mt-auto ml-4' />
  </aside>
  )

  return (
    <>
      <aside className='sidebar-component d-none d-lg-flex flex-column col-lg-2 pt-5 pl-4'>
        <nav className='pl-2'>
          <ul>
            {data.map(i => (
              <li key={shortId()}>
                <NavLink activeClassName='is-active' to={i.url} onClick={() => handleLinkClick(i.title)}>
                  <Icon className={styles.icon} name={i.iconName} />
                  {i.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <Footer className='mt-auto mb-3' />
      </aside>
      <MobileSidebar />
    </>
  );
};
